import type { SelectOption } from '@chatsdet/ui';
import { INSTANCE_SIZES, INSTANCE_SIZE_SPEC } from '@chatsdet/types';

export const INSTANCE_SIZE_OPTIONS: SelectOption[] = INSTANCE_SIZES.map((size) => {
  const spec = INSTANCE_SIZE_SPEC[size];
  return {
    id: size,
    label: `${size} — ${spec.vcpu} vCPU, ${spec.memoryMiB / 1024} GiB`,
  };
});
